Pegasus.ApplicationRoute = Ember.Route.extend({
  setupController:function(){
    this._super();
  },

  helpManager: function(){
    return Pegasus.HelpManager.create();
  }.property(),

  actions: {
    showShareDetails: function(){
      var self = this,
        controller = this.controllerFor('toolbar');
      import('~/pegasus/lazy_components/modals/share_details.js').then(function(){
        Em.run( self.controllerFor('modal'), 'set', 'presenter', Pegasus.ShareDetailsPresenter.create({
          toolbarController: controller
        }));
      });
    },

    suggestTemplateResize: function(content){
      this.controllerFor('modal').set('presenter', Pegasus.IntrinsicContentConflictPresenter.create({
        content: content
      }));
    },

    saveAborted: function(){
      this.controllerFor('template').set('isSaving', false);
    },

    dismissHelpContext: function(){
      this.set('activeHelpContext.isDismissed', true);
      this.set('activeHelpContext', this.get('helpManager.idling'));
      this.get('helpManager.idling').position();
    },

    setHelpContext: function(name){
      if ( this.get('activeHelpContext') ) {
        this.send('dismissHelpContext');
      }

      var helpContext = this.get('helpManager.' + name );
      if ( helpContext && !helpContext.get('isDismissed') ) {
        Em.run.next(this, function(){
          this.set('activeHelpContext', helpContext);
          helpContext.position();
        });
      }
    },

    hideHidden: function(){
      this.controllerFor('frameCommManager').hideHidden();
    },
    showHidden: function(){
      this.controllerFor('frameCommManager').showHidden();
    },
    requestTemplateImages: function(){
      this.controllerFor('frameCommManager').send('requestTemplateImages');
    },
    didLoadTemplateImages: function(image){
      var controller = this.controllerFor('imageGallery');
      if ( controller.get('zeroPagePhotos').filterProperty('src', image.src ).length ) { return; }
      controller.get('zeroPagePhotos').addObject(image);
    },
    documentLoaded: function(){
      $('.vr-opening').remove();
      var afterLoad = Pegasus.get('options.afterLoad');
      Pegasus.set('options.afterLoad', '');
      if ( afterLoad ) {
        Em.run.next(this, 'send', afterLoad);
      }
      Em.run.next(this.controllerFor('application'), 'set', 'documentsLoaded', true);
    },
    navigatingCommands: function(){
      this.controllerFor('toolbar').set('panelMode', 'Edit');
      this.controllerFor('frameCommManager').send('enteredIdleState');
    },
    showWidgetCodeModal: function(){
      var content = this.controllerFor('toolbar').get('content'),
        modalController = this.controllerFor('modal');

      var overlay = $('<div class="overlay-async"/>');
      overlay.appendTo('body');

      import( /* webpackChunkName: "code_mirror" */ 'code_mirror').then(function(){
        overlay.remove();
        modalController.set('presenter', Pegasus.WidgetCodeModal.create({
          content: content
        }));
      });
    },

    externallyEncodeImage: function(url) {
      this.controllerFor('frameCommManager').send('requestExternalImageTransformation', url);
    },
    escape: Em.K,
    saveNewContactList: function(name){
      this.controllerFor('frameCommManager').send('createContactList', {
        name: name
      });
    },
    exitReplacer: function(){
      $('.replace-overlay').removeClass('open');
    },
    touchedBlock: function(){
      this.controllerFor('toolbar').set('touched', true);
      if ( !$('.edit-tab.active').length ) {
        $('.edit-tab').click();
      }
    },
    didLoadEditor: function(){
      this.controllerFor('frameCommManager').say(window.parent, {
        method: 'didLoadEditor',
        payload: {}
      });
    },

    requestSnapshotThen: function(endpoint) {
      var self = this;

      this.controllerFor('template').set('isSaving', true);

      // Prevent autosave once the user has initiated a transfer
      this.controllerFor('autoSave').set('lastVersion', Em.get(Pegasus.CommandManager, 'instance.version'));
      var controller = this.controllerFor('frameCommManager');

      Pegasus.IOManager.generateOutput(true, function(handoffObject){
        Em.run(this, function(){
          controller.set('handoffPayload', handoffObject);
          controller.say(window.parent, {
            method: endpoint,
            payload: handoffObject
          });
        });
      }.bind(this));
    },

    saveAndExit: function(){
      this.send('requestSnapshotThen', 'saveAndExit');
    },
    saveAndContinue: function(){
      this.send('requestSnapshotThen', 'saveAndContinue');
    },
    saveAndSendTestEmail: function(){
      this.controllerFor('frameCommManager').prepareSendTestEmail();
      this.send('saveAndContinue');
    },
    saveAndGoToTestKit: function(){
      this.controllerFor('frameCommManager').prepareGoToTestKit();
      this.send('saveAndContinue');
    },
    tryUpgrading: function(){
      this.controllerFor('frameCommManager').requestUpgradeModal();
    },
    didSave: Ember.K,
    didSendTest: function(){
      this.controllerFor('template').set('isSaving', false);
      Pegasus.set('status', 'editing');
      Pegasus.stateMachine.transitionTo('idling');
    },
    setEditorStatusToEditing: function(){
      Pegasus.set('status', 'editing');
    },
    showTemplate: function(template){
      this.controllerFor('toolbar').setProperties( template.data );
      this.transitionTo('template', template.model);
    },
    clearRows: function(){
      this.controllerFor('toolbar').send('clearRows');
    },
    gotoLoading: function(){
      this.transitionTo('loading');
    },

    validateFields: function(){
    },

    notificationError: function(yml){
      this.controllerFor('frameCommManager').send('notificationError', yml);
    },

    showFeedback: function(){
      this.controllerFor('frameCommManager').send('provideFeedback');
    },

    showEditorHelpVideo: function(){
      this.controllerFor('frameCommManager').send('showEditorHelpVideo');
    },

    showHelp: function(){
      import('~/pegasus/lazy_components/controls/help/index.js').then(function(){
        Em.run(this.controllerFor('application'), 'set', 'shouldShowHelpMenu', true);
      }.bind(this));
    },

    setContext: function(context){
      Pegasus.setProperties({
        nextCopy: context.nextCopy,
        blockedFromSendEmail: context.blockedFromSendEmail,
        implementorLogo: context.implementorLogo
      });
    },

    displayConfirmationError: function(args) {
      if(Pegasus.stateMachine.currentState.name == 'confirming') {
        var errors = args.errors, showConfirmationModal = args.displayModal;
        var activation_error = false, keys = [];

        for(var i in errors) {
          keys.push(i);
        }

        // We want to show the modal only on the last step of AR confirmation
        if(keys.length == 1 &&
          errors.message) {

          errors.message.forEach(function(err) {
            if(err == Em.I18n.t('activerecord.errors.models.autoresponder.attributes.user.not_confirmed')) {
              activation_error = true;
            }
          });
        }

        if(activation_error) {
          // We need this in order for editor to allow edition after error
          Pegasus.stateMachine.transitionTo('idling');

          // Show email account verification modal
          showConfirmationModal();
        }
      }
    },

    deleteSavedImage: function(image) {
      var id = parseInt(
        image.src.split(/\/images\//).get('lastObject'),
        10
      );

      if ( isNaN( id ) ) { return; }

      this.controllerFor('frameCommManager').deleteSavedImage(id);
    }

  }
});

Pegasus.IndexRoute = Ember.Route.extend({
  redirect: function(){
    if ( !Em.testing ) {
      this.transitionTo( 'loading' );
    }
  }
});
